import * as React from 'react'
import cx from 'classnames'
import styles from './NoOpportunitySelected.sass'
import { EmptyState, EmptyStateIllustrationImage } from 'components/EmptyState'
import { useBrandingSettings } from 'hooks/branding'

interface NoOpportunitySelectedProps {}

export default function NoOpportunitySelected({}: NoOpportunitySelectedProps) {
  const { corporateMode } = useBrandingSettings()
  return (
    <div className={cx(styles.root)}>
      <div className={styles.content}>
        <EmptyState
          hideIllustration={corporateMode}
          animate
          small
          title="Having trouble spotting opportunity details?"
          subtitle="Simply select an opportunity card on the left to discover more details around the work required."
          image={
            <EmptyStateIllustrationImage
              alt="Woman with binoculars"
              src={require('assets/images/img_discover.svg')}
            />
          }
        />
      </div>
    </div>
  )
}
